import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import SignIn from './SignIn';
import SignInAr from './SignInAr';
import ForgotPassword from './ForgotPassword';
import LoginWithPhone from './LoginWithPhone';
import CheckIn from './CheckIn'; 
import SignUp from './SignUp';
import F1Logo from '../../assets/images/F1Logo.png';
import HrApprovaWhiteImage from '../../assets/images/hrapprova-white-footer-removebg.png';
import * as actions from '../../store/actions/index';
import ChendhurLogo from '../../assets/images/Chenthoor_landscape_Logo-removebg-preview.png';
import ChendhurLogowithbg from '../../assets/images/Chenthoor_landscape_Logo.png';
import {Toast} from 'primereact/toast';
import { TabView, TabPanel } from 'primereact/tabview';


class Login extends Component{
    state = {
        loginScreen : {
            login: false,
            forgotPass: false,
            signUp: false,
            loginPhone: false,
            loginAr:false,
            CheckIn:true,
            

        },
        Switch: "Switch To Arabic",
        Version: "Version 4.0",
    }

    SwitchLanguage = () => {
        let  Lang = localStorage.getItem('Lang');
        
        if(Lang=="En"){
            localStorage.setItem('Lang', "Ar");   
            this.setState({ Switch: "التبديل إلى اللغة الإنجليزية" });
            let loginScreen = {...this.state.loginScreen};        
            loginScreen.loginAr = true;
            loginScreen.login = false;
            this.setState({loginScreen:loginScreen,Version: "الإصدار ٤.٠"});
        } else {
            localStorage.setItem('Lang', "En"); 
            this.setState({ Switch: "Switch To Arabic" });
            let loginScreen = {...this.state.loginScreen};        
            loginScreen.loginAr = false;
            loginScreen.login = true;
            this.setState({loginScreen:loginScreen, Version: "Version 4.0"});
        }
    }

    showContainer = (e, type) => {
        e.preventDefault();
        let loginObject = {...this.state.loginScreen};
        Object.keys(loginObject).forEach(v => loginObject[v] = false);
         
        loginObject[type] = true;
        this.setState({loginScreen:loginObject})
        
    }

    componentDidMount(){
        let loginScreen = {...this.state.loginScreen};
        loginScreen.login = true;
        this.setState({loginScreen:loginScreen});
        this.props.getMasterTableList('Company/GetCompany');
        if (localStorage.getItem('Lang') == null) {
            localStorage.setItem('Lang', "En");
            this.setState({ Switch: "Switch To Arabic" });
        }
    }

    // The login succeeded: the authentication response has put this user's
    // default page in redux (see the auth reducer), so leave the login page for
    // it. Whichever of the sign-in screens below was used, they all end here.
    //
    // Watched from this component, not from inside a sign-in screen, and driven
    // by defaultPage rather than by the token: the response lands (defaultPage
    // set) a moment before authSuccess flips the token, and that flip makes
    // App.js swap the whole login branch for the staff shell — which unmounts
    // this subtree, so a <Redirect> rendered in reaction to the token never gets
    // the chance to navigate. That is what left the sidebar loading while the
    // URL stayed on /login.
    componentDidUpdate(prevProps){
        const { defaultPage } = this.props;

        if (defaultPage && defaultPage !== prevProps.defaultPage) {
            this.props.history.push(defaultPage);
        }
    }

    render(){

        let content = '';
        let title = '';
        const Lang = localStorage.getItem('Lang');
        if(this.props.companyData && this.props.companyData.company !==undefined){
            content= this.props.companyData.company.loginPageText;
            title = this.props.companyData.company.modifiedby;
        }
        content = "Chenthoor Restaurant HR Management Portal";
        // content = "Arabian Pipe Coating Company (APCO)"
        if (Lang == "Ar")
        {
            title = "مرحبًا بك في بوابة الخدمة الذاتية للموظفين والمديرين";
            content = "تشندور";
        }

        return(
            
            // <TabView>
            // <TabPanel header="Login">
            <div>
                <div id="login-wrapper" className="loginpage">
                    <div className="login-container">
                        <div className="login-left">
                            <h2 className="login-title">{title}</h2>
                            <h3>{content}</h3>
                            <img src={ChendhurLogo} alt="Chenthoor" className="center-logo" style={{maxWidth: '280px', margin: '20px 0'}} />
                            <img src={HrApprovaWhiteImage} alt="HR Approva" className="mini-logo" />
                        </div>
                        <div className="login-right">
                            <img className="login-image login-image-desktop" src={F1Logo} alt="HR Approva" />
                            <img className="login-image login-image-mobile" src={ChendhurLogowithbg} alt="Chenthoor" style={{width: '100%', maxWidth: '100%'}} />
                            {/* <img className="login-image" src={ChendhurLogowithbg} alt="Chenthoor" /> */}
                            {/* <div style={{backgroundColor: '#0d5d6f', padding: '20px', borderRadius: '10px', marginBottom: '20px'}}>
                                <img className="login-image" src={ChendhurLogo} alt="Chenthoor" style={{maxWidth: '120px', margin: '0 auto'}} />
                            </div> */}
                            {this.state.loginScreen.login && <SignIn />}
                            {this.state.loginScreen.loginAr && <SignInAr />}
                            {this.state.loginScreen.forgotPass && <ForgotPassword />}
                            {this.state.loginScreen.loginPhone && <LoginWithPhone />}
                            {this.state.loginScreen.signUp && <SignUp />}
                            

                            {this.state.loginScreen.login && (
                            <Link
                                to="#"
                                className="login-link"
                                onClick={(e) => this.showContainer(e, 'signUp')}
                            >
                                Create Account
                            </Link>
                             )}

                            <div className="login-link-container">
                                {/* <input type="submit" value={this.state.Switch} name="Switch" id="lang" className="login-button" onClick={this.SwitchLanguage} /> */}
                                { (this.state.loginScreen.forgotPass || this.state.loginScreen.signUp || this.state.loginScreen.loginPhone || this.state.loginScreen.forgotPass) && (
                                    <Link style={{ marginTop: "10px", marginRight: '10px' }} to="#" className="login-link signIn" onClick={(e) => this.showContainer(e, 'login')}>
                                        Login With User ID
                                    </Link>
                                )}
                                <h4>{this.state.Version}</h4>
                                <img className="login-image-mobile-small" src={F1Logo} alt="HR Approva" />
                            </div>
                        </div>
                    </div>
                </div>
             {/* </TabPanel> */}
              {/* <TabPanel header="Check-In">
                <div id="checkin-wrapper"  className="loginpage">
                <div className="login-container">
                        <div className="login-left">
                            <h2 className="login-title">{title}</h2>
                            <h3>{content}</h3>
                            <img src={ChendhurLogo} alt="Chenthoor" className="center-logo" style={{maxWidth: '280px', margin: '20px 0'}} />
                            <img src={HrApprovaWhiteImage} alt="HR Approva" className="mini-logo" />
                        </div>
                        <div className="login-right">
                            <img className="login-image" src={F1Logo} alt="HR Approva" />
                            <div style={{backgroundColor: '#0d5d6f', padding: '20px', borderRadius: '10px', marginBottom: '20px'}}>
                                <img className="login-image" src={ChendhurLogo} alt="Chenthoor" style={{maxWidth: '120px', margin: '0 auto'}} />
                            </div>
                            
                            {this.state.loginScreen.CheckIn && <CheckIn />}
                            

                            <div className="login-link-container">
                                <input type="submit" value={this.state.Switch} name="Switch" id="lang" className="login-button" onClick={this.SwitchLanguage} />
                                { (this.state.loginScreen.forgotPass || this.state.loginScreen.signUp || this.state.loginScreen.loginPhone || this.state.loginScreen.forgotPass) && (
                                    <Link style={{ marginTop: "10px", marginRight: '10px' }} to="#" className="login-link signIn" onClick={(e) => this.showContainer(e, 'login')}>
                                        Login With User ID
                                    </Link>
                                )}
                                <h4>{this.state.Version}</h4>
                            </div>
                        </div>
                    </div>
                </div>
                </TabPanel> */}
        {/*  </TabView> */}
                </div>
    );
    }


}



const mapStateToProps = state => {
    return {
        error : state.auth.error,
        loading : state.auth.loading,
        isAuthenticated : state.auth.token !== null,
        companyData : state.master.tableLists,
        defaultPage : state.auth.defaultPage,
    }
}

const mapDispatchToProps = dispatch => {
    return{
        onAuth : (email, password,Ar, isSignUp) => dispatch(actions.auth(email, password,Ar, isSignUp)),
        getMasterTableList: (table) => dispatch(actions.getMasterTableList(table)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);